import { render } from "./ConfinedSpaceTable.vue?vue&type=template&id=237dbd96&scoped=true"
import script from "./ConfinedSpaceTable.vue?vue&type=script&lang=js"
export * from "./ConfinedSpaceTable.vue?vue&type=script&lang=js"

import "./ConfinedSpaceTable.vue?vue&type=style&index=0&id=237dbd96&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237dbd96"]])

export default __exports__